"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultStyles = exports.getEditorStyles = exports.getTheme = exports.getColumns = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _themeOptions = require("../../helpers/theme-options");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  ul,\n  ol {\n    color: ", ";\n    margin: 0;\n  }\n\n  ", "\n\n  .paragraph-p3 {\n    ", " {\n      font-size: 12px;\n      line-height: 18px;\n    }\n  }\n\n  h1 {\n    font-size: 48px;\n    line-height: 60px;\n\n    .font-tertiary {\n      font-size: 120px;\n    }\n\n    ", " {\n      font-size: 36px;\n      line-height: 45px;\n\n      .font-tertiary {\n        font-size: 100px;\n      }\n    }\n\n    ", " {\n      font-size: 32px;\n      line-height: 40px;\n    }\n  }\n\n  h2 {\n    font-size: 40px;\n    line-height: 48px;\n\n    .font-tertiary {\n      font-size: 100px;\n    }\n\n    ", " {\n      font-size: 32px;\n      line-height: 40px;\n\n      .font-tertiary {\n        font-size: 90px;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 32px;\n    line-height: 40px;\n\n    .font-tertiary {\n      font-size: 90px;\n    }\n\n    ", " {\n      font-size: 24px;\n      line-height: 36px;\n\n      .font-tertiary {\n        font-size: 72px;\n      }\n    }\n  }\n\n  h4 {\n    font-size: 24px;\n    line-height: 36px;\n\n    .font-tertiary {\n      font-size: 72px;\n    }\n\n    ", " {\n      font-size: 18px;\n      line-height: 27px;\n\n      .font-tertiary {\n        font-size: 54px;\n      }\n    }\n  }\n\n  h5 {\n    font-size: 18px;\n    line-height: 27px;\n\n    .font-tertiary {\n      font-size: 54px;\n    }\n\n    ", " {\n      font-size: 14px;\n      line-height: 21px;\n\n      .font-tertiary {\n        font-size: 36px;\n      }\n    }\n  }\n\n  h6 {\n    font-size: 14px;\n    line-height: 21px;\n\n    .font-tertiary {\n      font-size: 36px;\n    }\n\n    ", " {\n      font-size: 12px;\n      line-height: 18px;\n\n      .font-tertiary {\n        font-size: 32px;\n      }\n    }\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    .font-tertiary {\n      color: ", ";\n    }\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  ul,\n  ol {\n    &:not(:last-child) {\n      margin-bottom: 30px;\n    }\n  }\n\n  p {\n    font-weight: ", ";\n\n    & + p {\n      margin-top: 30px;\n    }\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n\n  a {\n    color: currentColor;\n\n    &:visited {\n      color: currentColor;\n    }\n  }\n\n  img {\n    max-width: 100%;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  .font-tertiary {\n    font-family: ", ";\n    font-weight: 400 !important;\n  }\n\n  .font-primary {\n    font-family: ", ";\n  }\n\n  .font-secondary {\n    font-family: ", ";\n  }\n\n  .paragraph-p1 {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 24px;\n  }\n\n  .paragraph-p2,\n  .paragraph-p3 {\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 21px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColumns = function getColumns(layout) {
  switch (layout) {
    case 'medium':
      return 8;

    case 'large':
      return 10;

    default:
      return 12;
  }
};

exports.getColumns = getColumns;

var getTheme = function getTheme(theme) {
  switch (theme) {
    case _themeOptions.ThemeBlockVariants.SEASHELL:
    case _themeOptions.ThemeBlockVariants.SEASHELL_BLOCK:
      return (0, _uiKit.css)(_templateObject(), _uiKit.Colors.secondaryLight);

    case _themeOptions.ThemeBlockVariants.MOCASSIN:
    case _themeOptions.ThemeBlockVariants.MOCASSIN_BLOCK:
      return (0, _uiKit.css)(_templateObject2(), _uiKit.Colors.secondary);

    case _themeOptions.ThemeBlockVariants.CLARET:
    case _themeOptions.ThemeBlockVariants.CLARET_BLOCK:
      return (0, _uiKit.css)(_templateObject3(), _uiKit.Colors.wine);

    case _themeOptions.ThemeBlockVariants.BLACK:
    case _themeOptions.ThemeBlockVariants.BLACK_BLOCK:
      return (0, _uiKit.css)(_templateObject4(), _uiKit.Colors.gray800);

    default:
      return "";
  }
};
/* stylelint-disable no-descending-specificity */


exports.getTheme = getTheme;

var getEditorStyles = function getEditorStyles() {
  return (0, _uiKit.css)(_templateObject5(), _uiKit.FontFamilyValue.tertiary, _uiKit.FontFamilyValue.primary, _uiKit.FontFamilyValue.secondary);
};

exports.getEditorStyles = getEditorStyles;

var getDefaultStyles = function getDefaultStyles() {
  return (0, _uiKit.css)(_templateObject6(), function (_ref) {
    var isDarkTheme = _ref.theme.isDarkTheme;
    return isDarkTheme ? _uiKit.Colors.white : _uiKit.Colors.gray800;
  }, getEditorStyles(), _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.lg, function (_ref2) {
    var isDarkTheme = _ref2.theme.isDarkTheme;
    return isDarkTheme ? _uiKit.Colors.white : _uiKit.Colors.primaryDark;
  }, _uiKit.FontWeightValue.thin);
};
/* stylelint-enable no-descending-specificity */


exports.getDefaultStyles = getDefaultStyles;